import { Card, Col, Container, Form, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSponsorshipTypes } from 'hooks/useBeneficiaries';
import { useFormContext } from 'react-hook-form';
import { RHFSelect } from 'components/common/form';
import { JUZ_OPTIONS } from 'components/beneficiaries/hafiz/HafizProgressCard';

const isHafizType = name => /hafiz|hifz/i.test(name || '');

const juzSelectOptions = JUZ_OPTIONS.map(n => ({
  label: `Juz ${n}`,
  value: String(n)
}));

export const SponsorshipTypeCard = ({ sectionRef, sideNavLink, isEdit }) => {
  const { sponsorshipTypes } = useSponsorshipTypes();
  const { watch, setValue } = useFormContext();

  const selectedTypes = watch('sponsorshipTypes') || [];
  // Only on a new profile: existing children record progress on the profile
  // page, where the history lives
  const showJuz =
    !isEdit &&
    selectedTypes.some(t =>
      isHafizType(
        t.typeName || sponsorshipTypes?.find(st => st.id === t.typeId)?.type
      )
    );

  const handleTypeToggle = (typeId, typeName) => {
    const currentTypes = [...selectedTypes];
    const existingIndex = currentTypes.findIndex(t => t.typeId === typeId);

    if (existingIndex >= 0) {
      // Remove if already selected
      currentTypes.splice(existingIndex, 1);
    } else {
      // Add new type
      currentTypes.push({ typeId, typeName });
    }

    setValue('sponsorshipTypes', currentTypes);
  };

  const isTypeSelected = typeId => selectedTypes.some(t => t.typeId === typeId);

  return (
    <Card className="border shadow-none mb-3" ref={sectionRef} id={sideNavLink}>
      <Card.Header className="pb-0">
        <div className="dFlexRowStartSpace pt-3">
          <Card.Title as="h5">Sponsorship Types</Card.Title>
        </div>
        <p className="text-muted mb-0 fs--1">Select one or more sponsorship types for this beneficiary</p>
      </Card.Header>
      <Card.Body>
        <Container className="p-0">
          {sponsorshipTypes?.map(({ type, id }) => (
            <div key={id} className="mb-2">
              <Form.Check
                type="checkbox"
                id={`type-${id}`}
                label={type}
                checked={isTypeSelected(id)}
                onChange={() => handleTypeToggle(id, type)}
              />
            </div>
          ))}
          {sponsorshipTypes?.length === 0 && (
            <p className="text-muted">No sponsorship types available. Add them in WeConnect Settings.</p>
          )}
          {showJuz && (
            <Row className="mt-3">
              <Col xs={12} sm={6} md={4}>
                <RHFSelect
                  name="initialJuz"
                  label="Juz currently being memorised"
                  options={juzSelectOptions}
                  isClearable
                  placeholder="Not recorded yet"
                  infoMessage="Saved as the first entry in the child's Hafiz progress."
                />
              </Col>
            </Row>
          )}
        </Container>
      </Card.Body>
    </Card>
  );
};

SponsorshipTypeCard.propTypes = {
  sectionRef: PropTypes.object,
  sideNavLink: PropTypes.string,
  isEdit: PropTypes.bool
};
